function getBbox(sortedSites, id, searchResult) {
  let lats = [
    sortedSites.features[id].geometry.coordinates[1],
    searchResult.coordinates[1],
  ]
  let lons = [
    sortedSites.features[id].geometry.coordinates[0],
    searchResult.coordinates[0],
  ]
  const sortedLons = lons.sort((a, b) => {
    if (a > b) {
      return 1
    }
    if (a.distance < b.distance) {
      return -1
    }
    return 0
  })
  const sortedLats = lats.sort((a, b) => {
    if (a > b) {
      return 1
    }
    if (a.distance < b.distance) {
      return -1
    }
    return 0
  })
  return [
    [sortedLons[0], sortedLats[0]],
    [sortedLons[1], sortedLats[1]],
  ]
}

export { getBbox }
